import get from "../../../utils/GetNested";
import getPrettyIntegrationName from "../../../utils/getPrettyIntegrationName";

const getEventName = (log) => {
	const type = log.integration_type;

	if (type === "csv" || type === "sftp-sync") {
		return `SFTP Sync: ${get(log, ["sftp_properties", "sftp_integration_name", "name"], "CSV Upload")}`;
	}
	if (type === "csv-upload") {
		return "CSV Upload";
	}
	if (type === "connect-workers") {
		const integrationName = get(log, ["integrationProperties", "integrationName"], "");
		const prettyIntegrationName = getPrettyIntegrationName(integrationName);
		return `${prettyIntegrationName} Integration Settings Update`;
	}
	if (type === "integration-sync") {
		return `${getPrettyIntegrationName(get(log, ["integrationProperties", "integrationName"], ""))} Integration`;
	}
	if (type === "public-api") {
		return "Public API";
	}
	return "";
};

export default getEventName;
